import React from "react";
import { cn } from "@/lib/utils";

function Card({ className, children }) {
  return (
    <div className={cn("rounded-soft border bg-white", className)}>{children}</div>
  );
}

function CardHeader({ children }) {
  return <div className="px-3 pt-3">{children}</div>;
}

function CardTitle({ className, children }) {
  return <h3 className={cn("text-lg font-semibold", className)}>{children}</h3>;
}

function CardContent({ className, children }) {
  return <div className={cn("px-3 pb-3", className)}>{children}</div>;
}

export { Card, CardHeader, CardTitle, CardContent };
